import { Box, Button, Chip, ChipProps, styled, SxProps, Theme, useTheme } from '@mui/material';
import { DataGridFont } from 'components/Typography';
import FlexBox from 'components/flexbox/FlexBox';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CommonCellProps {
    title?: React.ReactNode;
    body?: React.ReactNode;
    sx?: SxProps<Theme>;
    leftIcon?: React.ReactNode;
    navigate?: string;
}

export const CommonCell: React.FC<CommonCellProps> = ({ title, body, sx, leftIcon, navigate }) => {
    const nav = useNavigate();
    return (
        <FlexBox sx={sx} flexDirection="row">
            {leftIcon}
            <FlexBox
                onClick={() => {
                    if (navigate) nav(navigate);
                }}
                sx={sx}
                flexDirection="column"
            >
                {!!title && (
                    <DataGridFont sx={sx} mb={0.5}>
                        {title}
                    </DataGridFont>
                )}
                <DataGridFont sx={{ ...sx, minHeight: 24, marginTop: `1px` } as SxProps<Theme>} color="text.secondary">
                    {body}
                </DataGridFont>
            </FlexBox>
        </FlexBox>
    );
};

export const EnvBanner = styled(Box)(() => ({
    background: `#C62D70`,
    borderRadius: 8,
    padding: `5px`,
    margin: `10px 20px 0`,
    color: `#FFF`,
    fontWeight: 700,
    textAlign: `center`,
}));

const darkChipColors: Record<string, string> = {
    success: `#27ce8899`,
    warning: `#FFC67599`,
    info: `#3A73FF99`,
    error: `#FF316F99`,
    secondary: `#734e5b99`,
};

interface LiChipProps extends ChipProps {
    errorBorder?: boolean;
}

export const LiChip: React.FC<LiChipProps> = ({ errorBorder, ...rest }) => {
    const theme = useTheme();
    return (
        <Chip
            {...rest}
            sx={{
                color: `#FFF`,
                width: `95px`,
                ...(theme.palette.mode === `dark` ? { backgroundColor: darkChipColors[rest.color as string] } : {}),
                ...(errorBorder ? { border: `2px solid ${theme.palette.error.main}` } : {}),
                ...(rest.sx ? rest.sx : {}),
            }}
            variant={rest.variant ?? `filled`}
        />
    );
};

export const SaveHeader = styled(Box)<{ therearechanges?: boolean }>(({ therearechanges, theme }) => ({
    height: therearechanges ? 65 : 0,
    transition: `height .5s ease`,
    display: `flex`,
    justifyContent: `center`,
    background: theme.palette.background.paper,
}));

export const CloseButton = styled(Button)(() => ({
    position: `absolute`,
    top: `0`,
    right: `0`,
    border: `none`,
    cursor: `pointer`,
    background: `none`,
    width: `50px`,
    height: `50px`,
}));
